import React from "react";
import {Button, Col, Divider, Form, Row, Select, Tooltip} from "antd";
import licenceValidation from "../licenceValidation";
import FormInput from "../../../components/FormInput/FormInput";
import DataType from "../../../constants/DataType";
import RightOutlined from "@ant-design/icons/es/icons/RightOutlined";
import CompanyLicenceDatatable from "./CompanyLicenceDatatable";
import CompanyLicenceList from "./CompanyLicenceList/CompanyLicenceList";

const SecondStepElements = ({licenceSavePending, availableSoftwareProductElements, availableExpiryActions, addLicenceElement,
                                licenceElements, removeLicenceElement, darkMode, primaryColor, isDeviceSmall}) => {

    return <Row gutter={[16, 16]}>
        <Col xs={24} lg={10}>

            <Divider orientation="left">Added Licence Elements</Divider>

            <Form.Item
                readOnly={licenceSavePending}
                label='SW Product Element'
                name='softwareProductElements'
                rules={licenceValidation.softwareProductElements}
            >
                <Select style={{width: '100%'}} placeholder={"SW Product Element"}
                        dropdownClassName={darkMode && 'dark-mode'}>
                    {
                        availableSoftwareProductElements.map(({id, code, description}) => (
                            <Select.Option key={id} value={id}>
                                <Tooltip title={description}>{code}</Tooltip>
                            </Select.Option>))
                    }
                </Select>
            </Form.Item>

            <FormInput readOnly={licenceSavePending} type={DataType.DOUBLE} label='Quantity'
                       placeholder='Quantity' name='quantity' min={1}
                       rules={licenceValidation.quantity}/>

            <Form.Item name='expiryLicenceActionId' label='Expiry Action' readOnly={licenceSavePending}
                       rules={licenceValidation.expiryLicenceActionId}>
                <Select style={{width: '100%'}} placeholder={"Select Expiry Action"}
                        dropdownClassName={darkMode && 'dark-mode'}>
                    {
                        availableExpiryActions.map(({id, code, description}) => (
                            <Select.Option key={id} value={id}>
                                <Tooltip title={description}>{code}</Tooltip>
                            </Select.Option>))
                    }
                </Select>
            </Form.Item>

            <FormInput readOnly={licenceSavePending} type={DataType.DATE} label='Expiry Date' disablePast={true}
                       placeholder='Expiry Date' name='expiryDate' rules={licenceValidation.expiryDate}/>

            <Form.Item className='save-button'>
                <Button onClick={addLicenceElement}>
                    Add Element to Licence
                    <RightOutlined type={'right'}/>
                </Button>
            </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
            <Divider orientation="left">Licence Data</Divider>

            {isDeviceSmall ?
                <CompanyLicenceList darkMode={darkMode} licenceElements={licenceElements} primaryColor={primaryColor}
                                    removeLicenceElement={removeLicenceElement}/> :
                <CompanyLicenceDatatable licenceElements={licenceElements}
                                         removeLicenceElement={removeLicenceElement}/>}
        </Col>
    </Row>
};

export default SecondStepElements;